import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParametreSanteFormComponent } from './parametre-sante-form.component/parametre-sante-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ParametreSanteFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    ParametreSanteFormComponent
  ]
})
export class ParametreSanteFormModule { }
